<div class="flex-row column ptb-45 plr-75 p-md-24 bg-color-202028">
  <div class="flex-row mb-15 position-relative content-between align-start">
    <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0" (click)="close()" aria-label="Close">
      <back-arrow-icon class="cursor-pointer mr-10 d-none-md" style="top: 1px;left: -45px" arrowColor="#FFC727"
        arrowWidth="30px" arrowHeight="30px" aria-hidden="true"></back-arrow-icon>
      <back-arrow-icon class="cursor-pointer mr-10 d-none-imp d-block-md" arrowColor="#FFC727" arrowWidth="30px"
        arrowHeight="30px" aria-hidden="true"></back-arrow-icon>
    </button>
    <div class="flex-row column d-none-md align-center">
      <div class="flex-row align-center column-gap-10 mb-8">
        <p class="color-F3F3F3 fs-24 fw-7 fs-md-18 tw-flex tw-gap-1">
          @if(data.call.callCategory == 'cash'){
          {{data.call.tradingSymbol}}
          }@else{
          {{data.call.scriptName + " |"}}
          {{(data.call.callCategory == 'future' || data.call.isMonthly) ? ((data.call.instrumentExpiry | date : 'MMM') +
          " |").toUpperCase() : ((data.call.instrumentExpiry | date : 'dd MMM').toUpperCase() + " |")}}
          @if(data.call.strike){
          {{data.call.strike + " |"}}
          }
          {{data.call.instrumentType}}
          }
          <!-- @if(data.call.callCategory == 'options'){
              <span class="tw-text-white tw-text-[8px] tw-leading-3 tw-border tw-border-solid tw-rounded-sm tw-border-white tw-py-0.5 tw-px-1 tw-max-h-fit">{{data.call.isMonthly ? 'M': 'W'}}</span>
            } -->
        </p>
        <div class="scriptTag {{data.call.scriptType}}">{{data.call.scriptType}} <span></span></div>
      </div>
      <span class="color-F3F3F3">CMP {{data.call.currentPrice | currency: 'INR':'symbol':'1.2-2'}}</span>
    </div>
    <span class="color-9DA6BF fs-md-12">{{data.isExit ? 'Exit':'Enter'}} Trade</span>
  </div>
  <div class="flex-row column full align-center d-none d-flex-md row-gap-8">
    <div class="scriptTag fs-md-12 {{data.call.scriptType}}">{{data.call.scriptType}} <span></span></div>
    <p class="color-F3F3F3 fs-18 fw-7 tw-flex tw-gap-1">
      @if(data.call.callCategory == 'cash'){
      {{data.call.tradingSymbol}}
      }@else{
      {{data.call.scriptName + " |"}}
      {{(data.call.callCategory == 'future' || data.call.isMonthly) ? ((data.call.instrumentExpiry | date : 'MMM') + "
      |").toUpperCase() : ((data.call.instrumentExpiry | date : 'dd MMM').toUpperCase() + " |")}}
      @if(data.call.strike){
      {{data.call.strike + " |"}}
      }
      {{data.call.instrumentType}}
      }
      <!-- @if(data.call.callCategory == 'options'){
          <span class="tw-text-white tw-text-[8px] tw-leading-3 tw-border tw-border-solid tw-rounded-sm tw-border-white tw-py-0.5 tw-px-1 tw-max-h-fit">{{data.call.isMonthly ? 'M': 'W'}}</span>
        } -->
    </p>
    <span class="color-F3F3F3 fs-14">CMP {{data.call.currentPrice | currency: 'INR':'symbol':'1.2-2'}}</span>
  </div>
  <ng-container *ngIf="!isManualEntry">
    <div class="flex-row full content-center">
      <div
        class="flex-row column content-between row-gap-50 full min-width-35 max-width-max max-width-md-100-pr full-md pt-50 height-md-100-pr">
        <ng-container *ngTemplateOutlet="orderBox"></ng-container>
        <div class="flex-row column full row-gap-15" *ngIf="!isTradeLoading">
          <span
            *ngIf="isMarketOpen && (userBroker && ((data.call.callCategory === 'future' || data.call.callCategory === 'options') && (userBroker !== 'zerodha' && userBroker !== 'nuvama')))"
            class="text-danger fs-13 text-center md:tw-max-w-[314px]">Currently not supporting selected broker for order
            placement. <br>
            Please place your order manually.</span>
          <span *ngIf="!isMarketOpen" class="text-danger fs-13 text-center">Order cannot be placed off market
            hours</span>
          <button type="button"
            [disabled]="!isMarketOpen || tradeCallForm.invalid || (userBroker && ((data.call.callCategory === 'future' || data.call.callCategory === 'options') && (userBroker !== 'zerodha' && userBroker !== 'nuvama')))"
            [class.disabled]="!isMarketOpen || tradeCallForm.invalid || (userBroker && ((data.call.callCategory === 'future' || data.call.callCategory === 'options') && (userBroker !== 'zerodha' && userBroker !== 'nuvama')))"
            class="btn btn-primary yellow" (debounceclicked)="tradeCall(false)" debounceClick>
            <ng-container *ngFor="let brokrage of brokrageList;let i=index">
              <div *ngIf="userBroker === brokrage.code" class="flex-row align-center content-center column-gap-10">
                <img src="assets/new-assets/partner/zerodha.png" *ngIf="brokrage.code=='zerodha'"
                  style="max-width: 30px;" [alt]="brokrage.code">
                <img src="assets/new-assets/partner/five-paisa.png" *ngIf="brokrage.code=='five_paisa'"
                  style="max-width: 30px;" [alt]="brokrage.code">
                <img src="assets/new-assets/partner/nuvama.png" *ngIf="brokrage.code=='nuvama'" style="max-width: 70px;"
                  [alt]="brokrage.code">
                <img src="assets/new-assets/partner/aditya-birla.svg" *ngIf="brokrage.code=='aditya_birla'"
                  style="max-width: 30px;" [alt]="brokrage.code">
                <img src="assets/new-assets/partner/bajaj-broking.png" *ngIf="brokrage.code=='bajaj_finserv'"
                  style="max-width: 60px;" [alt]="brokrage.code">
                <img src="assets/new-assets/partner/angel-broking.png" *ngIf="brokrage.code=='angel_broking'"
                  style="max-width: 30px;" [alt]="brokrage.code">
                <img src="assets/new-assets/partner/alice-blue.svg" *ngIf="brokrage.code=='alice_blue'"
                  style="max-width: 30px;" [alt]="brokrage.code">
                <img src="assets/new-assets/partner/klever-trade.png" *ngIf="brokrage.code=='klever_trade'"
                  style="max-width: 30px;" [alt]="brokrage.code">
                <img src="assets/new-assets/partner/master-trust.png" *ngIf="brokrage.code=='master_trust'"
                  style="max-width: 30px;" [alt]="brokrage.code">
                <img src="assets/new-assets/partner/trade-smart.png" *ngIf="brokrage.code=='trade_smart'"
                  style="max-width: 30px;" [alt]="brokrage.code">
                <img src="assets/new-assets/partner/finvasia-shoonya.jpg" *ngIf="brokrage.code=='finvasia'"
                  style="max-width: 60px;" [alt]="brokrage.code">
                <img src="assets/new-assets/partner/zebu.png" *ngIf="brokrage.code=='ZEBU'" style="max-width: 40px;"
                  [alt]="brokrage.code">
                <img src="assets/icons/upstox.svg" *ngIf="brokrage.code === 'upstox'" class="max-width-4"
                  [alt]="brokrage.code">
                <img src="assets/brokerage/paytm.png" *ngIf="brokrage.code === 'paytm'" class="max-width-4"
                  [alt]="brokrage.code">
                <img src="assets/brokerage/ventura.jpeg" *ngIf="brokrage.code === 'ventura'" [alt]="brokrage.code"
                  class="max-width-4">
                Trade with {{brokrage.name}}
              </div>
            </ng-container>
          </button>
          <div class="flex-row align-center column-gap-10 color-9DA6BF fs-14 full content-center">
            <button type="button" class="cursor-pointer btn p-0" (click)="goToProfile()">Change Broker</button>
            <span>|</span>
            <button type="button" class="cursor-pointer btn p-0" (click)="isManualEntry = true">Trade Manual</button>
          </div>
        </div>
        <ng-container *ngIf="isTradeLoading">
          <!-- <app-loader></app-loader> -->
          <div class="container full flex-row align-center content-center height-100-pr mt-50 mt-md-48">
            <app-lotti-animation path="/lottie/trading/tradingpackloader.json"
              class="tw-w-[60px] tw-h-[60px]"></app-lotti-animation>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isManualEntry">
    <div
      class="flex-row column-gap-40 full column row-gap-md-32 height-md-100-pr content-between-md content-center align-center">
      <div
        class="width-45-pr flex-row column content-between row-gap-50 min-width-max pt-50 pt-md-0 full-md row-gap-md-40">
        <ng-container *ngTemplateOutlet="manualOrderBox"></ng-container>
        <ng-container *ngIf="!isTradeLoading">
          <div class="flex-row full column row-gap-10 align-center">
            <span *ngIf="!isMarketOpen" class="text-danger fs-13 text-center">Order cannot be placed off market
              hours</span>
            <span
              *ngIf="isMarketOpen && (userBroker && ((data.call.callCategory === 'future' || data.call.callCategory === 'options') && (userBroker !== 'zerodha' && userBroker !== 'nuvama')))"
              class="text-danger fs-13 text-center md:tw-max-w-[314px]">Currently not supporting selected broker for
              order placement. <br>
              Please place your order manually.</span>
            <button type="button"
              [disabled]="tradeCallForm.invalid || !isMarketOpen || (userBroker && ((data.call.callCategory === 'future' || data.call.callCategory === 'options') && (userBroker !== 'zerodha' && userBroker !== 'nuvama')))"
              [class.disabled]="!isMarketOpen || (userBroker && ((data.call.callCategory === 'future' || data.call.callCategory === 'options') && (userBroker !== 'zerodha' && userBroker !== 'nuvama')))"
              class="btn btn-primary yellow flex-row align-center content-center column-gap-10 full"
              (click)="brokerLogin()">
              <ng-container *ngFor="let brokrage of brokrageList;let i=index">
                <div *ngIf="userBroker === brokrage.code" class="flex-row align-center content-center column-gap-10">
                  <img src="assets/new-assets/partner/zerodha.png" *ngIf="brokrage.code=='zerodha'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/five-paisa.png" *ngIf="brokrage.code=='five_paisa'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/nuvama.png" *ngIf="brokrage.code=='nuvama'"
                    style="max-width: 70px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/aditya-birla.svg" *ngIf="brokrage.code=='aditya_birla'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/bajaj-broking.png" *ngIf="brokrage.code=='bajaj_finserv'"
                    style="max-width: 60px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/angel-broking.png" *ngIf="brokrage.code=='angel_broking'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/alice-blue.svg" *ngIf="brokrage.code=='alice_blue'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/klever-trade.png" *ngIf="brokrage.code=='klever_trade'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/master-trust.png" *ngIf="brokrage.code=='master_trust'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/trade-smart.png" *ngIf="brokrage.code=='trade_smart'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/finvasia-shoonya.jpg" *ngIf="brokrage.code=='finvasia'"
                    style="max-width: 60px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/zebu.png" *ngIf="brokrage.code=='ZEBU'" style="max-width: 40px;"
                    [alt]="brokrage.code">
                  <img src="assets/icons/upstox.svg" *ngIf="brokrage.code === 'upstox'" class="max-width-4"
                    [alt]="brokrage.code">
                  <img src="assets/brokerage/paytm.png" *ngIf="brokrage.code === 'paytm'" class="max-width-4"
                    [alt]="brokrage.code">
                  {{isBrokerValid ? 'Proceed with broker': brokrage.name+' Login '}}
                </div>
              </ng-container>
              <ng-container *ngIf="!userBroker">
                {{isBrokerValid ? 'Proceed with broker':'Login with broker'}}
              </ng-container>
              <arrow-icon arrowColor="#202028" angle="right" arrowHeight="12px" arrowWidth="12px"></arrow-icon>
            </button>
            <button type="button" [disabled]="tradeCallForm.invalid" [class.disabled]="tradeCallForm.invalid"
              class="btn btn-yellow-outline bg-none yellow full" (debounceclicked)="tradeCall(true)" debounceClick
              [debouncetime]="300">Place order externally</button>
            <div class="flex-row align-center column-gap-10 color-9DA6BF fs-14 full content-center">
              <button type="button" class="cursor-pointer btn p-0" (click)="goToProfile()">Change Broker</button>
              <!-- <span>|</span>
              <span class="cursor-pointer" (click)="isManualEntry = true">Trade Manual</span> -->
            </div>
            <p class="color-9DA6BF fs-12">This data helps manage your external transactions.</p>
            <!-- <ng-container *ngIf="data.tradeData?._id">
              <button class="btn btn-link bg-none yellow full" *ngIf="!data.isExit" (click)="tradeCall(true)">Order placed externally</button>
              <button class="btn btn-link bg-none yellow full" *ngIf="data.isExit" (click)="tradeCall(true)">Order placed externally</button>
            </ng-container> -->
          </div>
        </ng-container>
        <ng-container *ngIf="isTradeLoading">
          <!-- <app-loader></app-loader> -->
          <div class="container full flex-row align-center content-center height-100-pr mt-50 mt-md-48">
            <app-lotti-animation path="/lottie/trading/tradingpackloader.json"
              class="tw-w-[60px] tw-h-[60px]"></app-lotti-animation>
          </div>
        </ng-container>
      </div>
      <!-- <div class="flex-row column row-gap-40 content-between align-center flex-row-md ">
        <div class="border-color-CECECE height-45-pr width-md-45-pr height-md-1-pr" style="opacity: 0.4;"></div>
        <p class="color-CECECE fs-12 rotate-270 rotate-md-0">OR</p>
        <div class="border-color-CECECE height-45-pr width-md-45-pr height-md-1-pr" style="opacity: 0.4;"></div>
      </div>
      <div
        class="flex-row column align-center content-center width-45-pr min-width-25 full-md height-md-45-pr pt-md-32">
        <img class="width-5 width-md-3" src="assets/trading/3-grey-stars.svg" alt="">
        <p class="color-9DA6BF text-center lh-26 mb-32 mt-16 mt-md-0 mb-md-16">{{isBrokerValid ? 'Proceed':'Login'}}
          with broker<br>
          to automate purchase</p>
        <button class="btn btn-link yellow bg-none p-0 flex-row align-center column-gap-10" (click)="brokerLogin()">
          {{isBrokerValid ? 'Proceed with broker':'Broker Login '}}
          <arrow-icon arrowColor="#FFC727" angle="right" arrowHeight="12px" arrowWidth="12px"></arrow-icon>
        </button>
      </div> -->
    </div>
  </ng-container>
</div>


<ng-template #manualOrderBox>
  <form [formGroup]="tradeCallForm" class="flex-row full column align-start row-gap-32 mt-md-8">
    <div class="flex-row column row-gap-10 full">
      <div class="flex-row align-center content-between">
        <p class="color-F3F3F3 fs-md-14">{{data.isExit ? 'Exit': 'Entry'}} Price</p>
        <span class="color-9DA6BF fs-12">per share</span>
      </div>
      <input type="number"
        class="plr-20 ptb-15 fs-18 color-F3F3F3 bg-color-2D2D39 border-radius-6 border-none border-color-focus-FFC727 width-35 full"
        formControlName="price">
      <span class="text-danger fs-12"
        *ngIf="tradeCallForm.controls.price.touched && !tradeCallForm.controls.price.errors?.required && tradeCallForm.controls.price.errors?.price">{{tradeCallForm.controls.price.errors?.price}}</span>
      <span class="text-danger fs-12"
        *ngIf="tradeCallForm.controls.price.touched && tradeCallForm.controls.price.errors?.required">Entry Price is
        required</span>
    </div>
    <div class="flex-row column row-gap-10 full">
      <div class="flex-row align-center content-between">
        <p class="color-F3F3F3 fs-md-14">Quantity</p>
        <span class="color-9DA6BF fs-12">Qty</span>
      </div>
      <input type="number"
        class="plr-20 ptb-15 fs-18 color-F3F3F3 bg-color-2D2D39 border-none border-radius-6 border-color-focus-FFC727 width-35 full"
        formControlName="quantity" placeholder="No. of shares" autofocus>
      <span class="fs-12 color-F3F3F3"
        *ngIf="data.call.callCategory === 'future' || data.call.callCategory === 'options'">1 Lot =
        {{data.call?.lotSize}}qty</span>
      <span class="text-danger fs-12"
        *ngIf="tradeCallForm.controls.quantity.touched && tradeCallForm.controls.quantity.errors?.required">Quantity is
        required</span>
      <span class="text-danger fs-12" *ngIf="tradeCallForm.controls.quantity.errors?.quantityNotMultiple">1 Lot is equal
        to {{data.call?.lotSize}}qty</span>
    </div>
  </form>
</ng-template>

<ng-template #orderBox>
  <form [formGroup]="tradeCallForm" class="flex-row full column align-start row-gap-32">
    <div class="flex-row align-center column-gap-25">
      <div class="flex-row align-center column-gap-10 color-F3F3F3">
        <input type="radio" class="yellow" value="LIMIT" formControlName="orderType">
        <label for="LIMIT">LMT</label>
      </div>
      <div class="flex-row align-center column-gap-10 color-F3F3F3">
        <input type="radio" value="MARKET" class="yellow" formControlName="orderType">
        <label for="MARKET">MKT</label>
      </div>
    </div>
    <div class="flex-row column row-gap-10 full">
      <div class="flex-row align-center content-between">
        <p class="text-uppercase color-F3F3F3">{{data.isExit ? 'Exit': 'Entry'}} Price</p>
        <span class="color-9DA6BF fs-12">per share</span>
      </div>
      <input type="number"
        class="plr-20 ptb-15 fs-18 color-F3F3F3 bg-color-2D2D39 border-radius-6 border-color-focus-FFC727 border-none full"
        formControlName="price" [ngClass]="{'tw-opacity-50': tradeCallForm.controls.price.disabled}">
      <span class="text-danger fs-12"
        *ngIf="tradeCallForm.controls.price.touched && !tradeCallForm.controls.price.errors?.required && tradeCallForm.controls.price.errors?.price">{{tradeCallForm.controls.price.errors?.price}}</span>
      <span class="text-danger fs-12"
        *ngIf="tradeCallForm.controls.price.touched && tradeCallForm.controls.price.errors?.required">Entry Price is
        required</span>
    </div>
    <div class="flex-row column row-gap-10 full">
      <div class="flex-row align-center content-between">
        <p class="text-uppercase color-F3F3F3">Quantity</p>
        <span class="color-9DA6BF fs-12">Qty</span>
      </div>
      <input type="number" placeholder="No. of shares"
        class="plr-20 ptb-15 fs-18 color-F3F3F3 bg-color-2D2D39 border-radius-6 border-color-focus-FFC727 border-none full"
        formControlName="quantity">
      <span class="fs-12 color-F3F3F3"
        *ngIf="data.call.callCategory === 'future' || data.call.callCategory === 'options'">1 Lot =
        {{data.call?.lotSize}}qty</span>
      <span class="text-danger fs-12"
        *ngIf="tradeCallForm.controls.quantity.touched && tradeCallForm.controls.quantity.errors?.required">Quantity is
        required</span>
      <span class="text-danger fs-12" *ngIf="tradeCallForm.controls.quantity.errors?.quantityNotMultiple">1 Lot is equal
        to {{data.call?.lotSize}}qty</span>

    </div>
    <ng-container *ngIf="tradeCallForm.get('complexty').value === 'BO'">
      <div class="flex-row column row-gap-10 full">
        <span class="fs-14 text-uppercase">Stop loss</span>
        <input type="number"
          class="plr-20 ptb-15 fs-18 color-F3F3F3 bg-color-2D2D39 border-radius-6 border-color-focus-FFC727 border-none full"
          formControlName="stopLoss">
      </div>
      <div class="flex-row column row-gap-10 full">
        <span class="fs-14 text-uppercase">Target</span>
        <input type="number"
          class="plr-20 ptb-15 fs-18 color-F3F3F3 bg-color-2D2D39 border-radius-6 border-color-focus-FFC727 border-none full"
          formControlName="target">
      </div>
    </ng-container>
    <div class="flex-row align-center column-gap-25 color-F3F3F3">
      <div class="flex-row align-center column-gap-10" *ngIf="data.call.callCategory === 'cash'">
        <input type="radio" value="CNC" class="yellow" formControlName="product">
        <label for="CNC">CNC</label>
      </div>
      <div class="flex-row align-center column-gap-10"
        *ngIf="!(data?.call?.label == 'intraday' && data?.call?.callCategory === 'cash')">
        <input type="radio" value="NRML" class="yellow" formControlName="product">
        <label for="NRML">NRML</label>
      </div>
      <div class="flex-row align-center column-gap-10 " *ngIf="data?.call?.label === 'intraday'">
        <input type="radio" value="MIS" class="yellow" formControlName="product">
        <label for="MIS">MIS</label>
      </div>
    </div>
    <div class="flex-row align-center column-gap-25 color-F3F3F3" *ngIf="data.call | isBOorder:userBroker">
      <div class="flex-row align-center column-gap-10 ">
        <input type="radio" value="REGULAR" class="yellow" formControlName="complexty">
        <label for="REGULAR">Regular</label>
      </div>
      <div class="flex-row align-center column-gap-10">
        <input type="radio" value="BO" class="yellow" formControlName="complexty">
        <label for="BO">BO</label>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #loginTemplate>
  <div class="flex-row full column align-start position-relative p-24 bg-color-202028">
    <button type="button" class="btn p-0 text-white close-modal mt-24 pr-24" (click)="closeBrokersDialog()">X</button>
    <div class="flex-row full column align-start row-gap-16">
      <h2 class="fs-22 fw-7 text-white">Login With your broker</h2>
      <div class="flex-row full align-center content-center">
        <div class="flex-row full flex-wrap content-center column-gap-16 row-gap-16 column-md-gap-11 row-gap-md-11">
          <ng-container *ngIf="!isBrokerLoading">
            <ng-container *ngFor="let brokrage of brokrageList;let i=index">
              <button type="button"
                class="btn p-10 bg-white border-1 btn-link fs-12 min-width-13 max-width-13 min-width-md-31-pr max-width-md-31-pr"
                (click)="selectBroker(brokrage)">
                <div class="flex-row full column align-center row-gap-8">
                  <img src="assets/new-assets/partner/zerodha.png" *ngIf="brokrage.code=='zerodha'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/five-paisa.png" *ngIf="brokrage.code=='five_paisa'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/nuvama.png" *ngIf="brokrage.code=='nuvama'"
                    style="max-width: 70px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/aditya-birla.svg" *ngIf="brokrage.code=='aditya_birla'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/bajaj-broking.png" *ngIf="brokrage.code=='bajaj_finserv'"
                    style="max-width: 60px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/angel-broking.png" *ngIf="brokrage.code=='angel_broking'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/alice-blue.svg" *ngIf="brokrage.code=='alice_blue'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/klever-trade.png" *ngIf="brokrage.code=='klever_trade'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/master-trust.png" *ngIf="brokrage.code=='master_trust'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/trade-smart.png" *ngIf="brokrage.code=='trade_smart'"
                    style="max-width: 30px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/finvasia-shoonya.jpg" *ngIf="brokrage.code=='finvasia'"
                    style="max-width: 60px;" [alt]="brokrage.code">
                  <img src="assets/new-assets/partner/zebu.png" *ngIf="brokrage.code=='ZEBU'" style="max-width: 40px;"
                    [alt]="brokrage.code">
                  <img src="assets/icons/upstox.svg" *ngIf="brokrage.code === 'upstox'" class="max-width-4"
                    [alt]="brokrage.code">
                  <img src="assets/brokerage/paytm.png" *ngIf="brokrage.code === 'paytm'" class="max-width-4"
                    [alt]="brokrage.code">
                  <p>{{brokrage.name}}</p>
                </div>
              </button>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="isBrokerLoading">
            <!-- <app-loader></app-loader> -->
            <div class="container full flex-row align-center content-center height-100-pr mt-50 mt-md-48">
              <app-lotti-animation path="/lottie/trading/tradingpackloader.json"
                class="tw-w-[60px] tw-h-[60px]"></app-lotti-animation>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>